// ===========================================================================
// High Cost — constantes compartidas del módulo.
//
// Paletas de color consistentes para Health Status (clínico) y categoría social
// global (capa SDOH), niveles de dimensión SDOH, categorías de costo y defaults
// de paginación. Reutilizadas en lista, análisis, ficha y estratificación.
// ===========================================================================

export const HIGH_COST_BASE_PATH = "/high-cost";

export const DEFAULT_PAGE_SIZE = 50;
export const PAGE_SIZE_OPTIONS = [25, 50, 100];

// Health Status clínico (Hability) — 7 valores. Color por severidad ascendente.
export const HEALTH_STATUS_COLORS = {
  Well: "#2e7d32",
  "At Risk": "#fbc02d",
  Acute: "#fb8c00",
  Chronic: "#ef6c00",
  Complex: "#c62828",
  "End of Life": "#6a1b9a",
  "No Status": "#9e9e9e",
};

// Categoría social GLOBAL (capa SDOH). Distinta del Health Status clínico.
export const SOCIAL_CATEGORY_COLORS = {
  Stable: "#2e7d32",
  Vulnerable: "#fbc02d",
  "High Social Risk": "#fb8c00",
  Critical: "#c62828",
  Unclassified: "#9e9e9e",
};

// Niveles de una dimensión SDOH (selector de 4 estados).
export const SDOH_LEVELS = [
  { key: "unknown", label: "Unknown", value: 0, color: "#9e9e9e" },
  { key: "stable", label: "Stable", value: 1, color: "#2e7d32" },
  { key: "at_risk", label: "At Risk", value: 2, color: "#fbc02d" },
  { key: "critical", label: "Critical", value: 3, color: "#c62828" },
];

// Las 7 dimensiones SDOH con su código Z (Z-codes ICD-10 sociales).
// Orden y códigos según la doc de UI/UX (CAT2_UIUX_HIGH_COST.md §6).
export const SDOH_DIMENSIONS = [
  { key: "economic_stability", label: "Economic Stability", zCode: "Z59.5" },
  { key: "education", label: "Education Access & Quality", zCode: "Z55" },
  { key: "healthcare_access", label: "Healthcare Access & Quality", zCode: "Z75" },
  { key: "neighborhood", label: "Neighborhood & Built Environment", zCode: "Z58" },
  { key: "social_context", label: "Social & Community Context", zCode: "Z60" },
  { key: "food", label: "Food Insecurity", zCode: "Z59.4" },
  { key: "transportation", label: "Transportation", zCode: "Z59.82" },
];

// Categorías de costo (desglose por servicio). Orden de presentación.
export const COST_CATEGORIES = [
  { key: "inpatientCost", label: "Inpatient", color: "#1565c0" },
  { key: "outpatientCost", label: "Outpatient", color: "#1976d2" },
  { key: "pharmacyCost", label: "Pharmacy", color: "#7b1fa2" },
  { key: "erCost", label: "ER", color: "#c62828" },
  { key: "professionalCost", label: "Professional", color: "#2e7d32" },
  { key: "ancillaryVisitCost", label: "Ancillary", color: "#00838f" },
  { key: "virtualVisitCost", label: "Virtual", color: "#5e35b1" },
];

// Health Status para el filtro (id = NUM_ID_HEALTH_STATUS del catálogo backend).
// El front envía el id; los nombres son para el dropdown.
export const HEALTH_STATUS_OPTIONS = [
  { label: "Well", displayOrder: 1 },
  { label: "At Risk", displayOrder: 2 },
  { label: "Acute", displayOrder: 3 },
  { label: "Chronic", displayOrder: 4 },
  { label: "Complex", displayOrder: 5 },
  { label: "End of Life", displayOrder: 6 },
  { label: "No Status", displayOrder: 7 },
];
